function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { PropTypes } from 'prop-types';
import cx from 'classnames';

require('xps-style/core/progressbar.css');

var ProgressBar = /*#__PURE__*/function (_React$Component) {
  _inherits(ProgressBar, _React$Component);

  var _super = _createSuper(ProgressBar);

  function ProgressBar() {
    _classCallCheck(this, ProgressBar);

    return _super.apply(this, arguments);
  }

  _createClass(ProgressBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          completed = _this$props.completed,
          total = _this$props.total,
          showStatus = _this$props.showStatus;
      var barClassNames = cx({
        progressbar: true,
        'progressbar-skin': true,
        'width-100p': true,
        'margintop-md': label || showStatus
      });
      var progressStyle = {
        width: "".concat(completed / total * 100, "%")
      };
      return /*#__PURE__*/React.createElement("div", {
        tabIndex: "0",
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuenow": completed,
        "aria-valuemax": total,
        className: "progressbar__container-skin  display-flex justify-content-between flex-wrap"
      }, label ? /*#__PURE__*/React.createElement("span", {
        className: "progressbar__label"
      }, label) : '', showStatus === true ? /*#__PURE__*/React.createElement("span", {
        className: "progressbar__status"
      }, completed, " of ", total, " Complete") : '', /*#__PURE__*/React.createElement("div", {
        className: barClassNames
      }, /*#__PURE__*/React.createElement("div", {
        className: "progressbar__line progressbar__line-skin",
        style: progressStyle
      })));
    }
  }]);

  return ProgressBar;
}(React.Component);

_defineProperty(ProgressBar, "propTypes", {
  /** label text of progress bar */
  label: PropTypes.string,

  /** Displays progress status */
  showStatus: PropTypes.bool,

  /** completion of progress bar */
  completed: PropTypes.number.isRequired,

  /** total possible completion point */
  total: PropTypes.number.isRequired
});

_defineProperty(ProgressBar, "defaultProps", {});

ProgressBar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProgressBar",
  "props": {
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "label text of progress bar"
    },
    "showStatus": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Displays progress status"
    },
    "completed": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": "completion of progress bar"
    },
    "total": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": "total possible completion point"
    }
  }
};
export default ProgressBar;